import React from "react";

//Material-ui imports
import { Button, SxProps, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

interface BtnWrapperProps {
  name: string;
  variant?: "text" | "outlined" | "contained" | undefined;
  size?: "small" | "medium" | "large";
  handleClick?: any;
  sx?: SxProps<Theme>;
  icon?: any;
  type?: any;
  disabled?: boolean;
}

const BtnWrapper = styled(Button)<{ size?: string }>(
  ({ theme, size, variant }) => ({
    borderRadius: "6px",
    fontSize: size === "small" ? "14px" : "16px",
    fontWeight: 500,
    lineHeight: size === "small" ? "17px" : "22px",
    color:
      variant === "contained"
        ? theme.palette.background.paper
        : theme.palette.secondary.dark,
    backgroundColor:
      variant === "contained" ? theme.palette.primary.dark : "transparent",
    textTransform: "capitalize",
    borderColor: theme.palette.primary.dark,
    padding: "11px 14px",
  })
);

// ======================== Main Button Component ================= //
const CustomButton = ({
  name,
  variant = "contained",
  size = "medium",
  handleClick,
  sx,
  icon,
  type,
  disabled = false,
}: BtnWrapperProps) => {
  return (
    <BtnWrapper
      variant={variant}
      size={size}
      sx={sx}
      onClick={handleClick}
      startIcon={icon ? icon : null}
      type={type}
      disabled={disabled}
    >
      {name}
    </BtnWrapper>
  );
};

export default CustomButton;
